import type { ComponentType, SVGProps } from "react";

type BannerProps = {
  text: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
};

export const Banner = ({ icon: Icon, text }: BannerProps) => {
  return (
    <div className="flex w-full items-center justify-center gap-4 rounded-card border border-success-line bg-success-surface px-5 py-5 text-content-secondary sm:px-8 sm:py-6">
      {Icon ? <Icon aria-hidden="true" className="hidden size-8 shrink-0 md:block" /> : null}
      <p className="text-center text-lg text-balance sm:text-xl">{text}</p>
    </div>
  );
};
